import { render, staticRenderFns } from "./FileShare.vue?vue&type=template&id=89f5017c&"
import script from "./FileShare.vue?vue&type=script&lang=js&"
export * from "./FileShare.vue?vue&type=script&lang=js&"
import style0 from "./FileShare.vue?vue&type=style&index=0&id=89f5017c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports